'use strict';

export default function($stateProvider) {
  'ngInject';
  $stateProvider
    .state('webaccess-edit', {
      url: '/webaccess/edit/:id',
      template: '<webaccess-edit></webaccess-edit>',
      authenticate: 'admin'
    });
}



// WEBPACK FOOTER //
// ./client/app/webaccess/edit/webaccess-edit.routes.js